import React, { useState,useEffect } from "react";
import amaxLogo from "../../images/amaxLogo.png";
import arrowNext from "../../images/arrowNext.svg";
import { Link,useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CoachStep3 = () => {

  const navigate = useNavigate();

  const [city,setCity] = useState('');
  const [state,setState] = useState('');

  /*const [dobOpen, setDobOpen] = useState(false);
  const [dob, setDob] = useState("Select");
  const dobOptions = ["1980", "1981", "1982","1983","1984","1985","1986","1987","1988","1989","1990", "1991","1992","1993","1994","1995","1996","1997","1998","1999","2000","2001","2002","2003","2004","2005","2006","2007","2008","2009","2010"];
*/

const [dob, setDob] = useState("");


  // State for radio button
  const [gender, setGender] = useState("");
  const [error, setError] = useState(null);


  /*const handleDOBClick = (option) => {
    setDob(option);
    setDobOpen(false);
  };*/

  useEffect(() => {
    // Restore data from sessionStorage
    const city_ = sessionStorage.getItem('city');
    const state_ = sessionStorage.getItem('state');
    const dob_ = sessionStorage.getItem('dob');
    const gender_ = sessionStorage.getItem('gender');

    if (city_) setCity(city_);
    if(state_) setState(state_);
    if (dob_) setDob(dob_);
    if(gender_) setGender(gender_);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!city || !state || !gender || !dob) {
      setError('Please enter all the details!');
      return;
    }

     setError(null);
     // Navigate to the second step with the form data
     //save the data in session
     sessionStorage.setItem("city",city);
     sessionStorage.setItem("state",state);
     sessionStorage.setItem("gender",gender);
     sessionStorage.setItem("dob",dob);

     navigate('/coach/register/step4');
  };

  
  // Format Date as MM-DD-YYYY for storage
  const formatDateForStorage = (date) => {
    if (!date) return "";
  
    const d = new Date(date);
  
    if (isNaN(d.getTime())) {
      console.error("Invalid date:", date); // Debugging check
      return "";
    }
  
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
    const day = String(d.getDate()).padStart(2, "0"); // Ensure two-digit day
    const year = d.getFullYear();
  
    console.log(`Formatted Date: ${month}-${day}-${year}`); // Debugging log
  
    return `${month}-${day}-${year}`; // Correct MM-DD-YYYY format
  };

      // Convert MM-DD-YYYY string from storage to a Date object for DatePicker
      const parseStoredDate = (dateStr) => {
        if (!dateStr) return null;
        const [month, day, year] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day);
      };
  
  

  return (
    <div className="p-[20px] bg-black h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-around items-center gap-[160px] overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>
        <div className="flex flex-col gap-[50px] w-full">
          <div className="flex flex-col justify-center gap-[15px]">
            <h1 className="text-white text-[40px] leading-[95%] uppercase font-light">
              COACH
              <br />
              PROFILE
            </h1>
            <div>
              <input
                type="text"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d] w-full mb-[15px]"
                placeholder="City*"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
              <input
                type="text"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d] w-full mb-[15px]"
                placeholder="State*"
                value={state}
                onChange={(e) => setState(e.target.value)}
              />
             
            </div>
            <div className="flex gap-[15px]">
                        {/* DOB Picker */}
                <div className="w-1/2 relative border border-white rounded-[15px] p-5 flex flex-col justify-between cursor-pointer">
                        <p className="text-white text-lg font-normal">DOB</p>
                        <div onClick={(e) => e.stopPropagation()} className="relative">
                          <DatePicker
                         selected={dob ? new Date(dob) : null}
                         onChange={(date) => {
                           console.log("Selected Date:", date); // Debugging log
                           setDob(formatDateForStorage(date));
                         }}
                         dateFormat="MM-dd-yyyy"
                         showYearDropdown
                         showMonthDropdown
                         dropdownMode="select"
                         className="bg-transparent text-white text-[28px] font-normal w-full focus:outline-none cursor-pointer"
                         placeholderText="MM-DD-YYYY"
                          />
                        </div>
                </div>

              <form  className="flex flex-col gap-[15px] w-[149px]">
                <p className="text-white text-lg font-normal ml-2">Gender</p>
                <div className="flex gap-2 w-full max-w-sm mx-auto justify-between">
                  <label className="flex items-center flex-col cursor-pointer">
                    <input
                      type="radio"
                      name="gender"
                      value="Male"
                      checked={gender === "Male"}
                      onChange={() => setGender("Male")}
                      className="hidden"
                    />
                    <span className={`w-[50px] h-[50px] rounded-full ${gender === "Male" ? "bg-white" : "bg-[#171717]"}`}></span>
                    <span className="text-white font-normal mt-[10px] text-sm">Male</span>
                  </label>
                  <label className="flex items-center flex-col cursor-pointer">
                    <input
                      type="radio"
                      name="gender"
                      value="Female"
                      checked={gender === "Female"}
                      onChange={() => setGender("Female")}
                      className="hidden"
                    />
                    <span className={`w-[50px] h-[50px] rounded-full ${gender === "Female" ? "bg-white" : "bg-[#171717]"}`}></span>
                    <span className="text-white font-normal mt-[10px] text-sm">Female</span>
                  </label>
                </div>
                </form>
              
            
            </div>
          </div>
        
               {/* Display Error Message */}
               {error && (
                  <p className="text-red-500 text-sm mt-2">
                    {error}
                  </p>
                )}

              <button
                type="button"
                onClick={handleSubmit}
                className="bg-white size-[70px] rounded-full flex justify-center items-center hover:bg-white/50 transition-all duration-300 ml-auto"
              >
                <img src={arrowNext} alt="arrow" className="object-contain" />
              </button>
         
        </div>
      </div>
    </div>
  );
};

export default CoachStep3;
